/**
 * Keystone file upload size limiter
 * Rejects files larger than 20MB and shows a popup asking the customer to upload a different file.
 */
(function () {
  if (window.__keystoneFileUploadLimitInit) return;
  window.__keystoneFileUploadLimitInit = true;

  var MAX_FILE_SIZE_MB = 20;
  var MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024;
  var ALERT_TITLE = 'File too large';
  var ALERT_MESSAGE =
    'The upload limit is ' + MAX_FILE_SIZE_MB + 'MB. The file you selected is larger than ' +
    MAX_FILE_SIZE_MB + 'MB. Please upload a different file.';

  var alertOpen = false;

  function isKeystoneFileInput(input) {
    if (!input || input.tagName !== 'INPUT' || input.type !== 'file') return false;

    if (input.id && input.id.indexOf('file_uf_') === 0) return true;
    if (input.name && input.name.indexOf('properties[') === 0) return true;

    return !!(
      input.closest &&
      input.closest('.key_options_form, .key_option_wrapper[data-option-type="uploadfile"], #key_options_block')
    );
  }

  function fileExceedsLimit(file) {
    return !!(file && file.size > MAX_FILE_SIZE);
  }

  function inputHasOversizedFile(input) {
    if (!input || !input.files || !input.files.length) return false;

    for (var i = 0; i < input.files.length; i++) {
      if (fileExceedsLimit(input.files[i])) return true;
    }

    return false;
  }

  function clearKeystoneFileInputs(input) {
    var scope = input;
    if (input.closest) {
      scope =
        input.closest('.key_option_wrapper') ||
        input.closest('.key_options_form') ||
        input;
    }

    var inputs =
      scope.querySelectorAll && scope !== input
        ? scope.querySelectorAll('input[type="file"]')
        : [input];

    for (var i = 0; i < inputs.length; i++) {
      try {
        inputs[i].value = '';
      } catch (e) {}
    }
  }

  function ensurePopupStyles() {
    if (document.getElementById('keystone-file-limit-styles')) return;

    var style = document.createElement('style');
    style.id = 'keystone-file-limit-styles';
    style.textContent =
      '#keystone-file-limit-overlay{position:fixed;inset:0;z-index:2147483646;display:flex;align-items:center;justify-content:center;padding:20px;background:rgba(0,0,0,.55);box-sizing:border-box;}' +
      '#keystone-file-limit-dialog{width:100%;max-width:420px;background:#fff;color:#111;border-radius:6px;box-shadow:0 12px 40px rgba(0,0,0,.28);padding:28px 24px 22px;font-family:Helvetica,Arial,sans-serif;text-align:center;}' +
      '#keystone-file-limit-dialog h2{margin:0 0 12px;font-size:20px;line-height:1.3;font-weight:700;}' +
      '#keystone-file-limit-dialog p{margin:0 0 22px;font-size:15px;line-height:1.5;}' +
      '#keystone-file-limit-ok{appearance:none;border:0;background:#111;color:#fff;min-width:120px;padding:12px 22px;font-size:14px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;cursor:pointer;border-radius:2px;}' +
      '#keystone-file-limit-ok:hover,#keystone-file-limit-ok:focus{background:#333;outline:none;}';
    document.head.appendChild(style);
  }

  function closePopup() {
    var overlay = document.getElementById('keystone-file-limit-overlay');
    if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
    document.removeEventListener('keydown', onEscape, true);
    alertOpen = false;
  }

  function onEscape(event) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      event.preventDefault();
      closePopup();
    }
  }

  function showLimitPopup() {
    if (alertOpen) return;
    alertOpen = true;
    ensurePopupStyles();

    var overlay = document.createElement('div');
    overlay.id = 'keystone-file-limit-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'keystone-file-limit-title');

    overlay.innerHTML =
      '<div id="keystone-file-limit-dialog">' +
      '<h2 id="keystone-file-limit-title">' +
      ALERT_TITLE +
      '</h2>' +
      '<p>' +
      ALERT_MESSAGE +
      '</p>' +
      '<button type="button" id="keystone-file-limit-ok">OK</button>' +
      '</div>';

    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) closePopup();
    });

    document.body.appendChild(overlay);
    document.addEventListener('keydown', onEscape, true);

    var okButton = document.getElementById('keystone-file-limit-ok');
    if (okButton) {
      okButton.addEventListener('click', closePopup);
      okButton.focus();
    }
  }

  function rejectOversizedUpload(input, event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }

    clearKeystoneFileInputs(input);
    showLimitPopup();
  }

  function onCaptureChange(event) {
    var input = event.target;
    if (!isKeystoneFileInput(input)) return;
    if (!inputHasOversizedFile(input)) return;
    rejectOversizedUpload(input, event);
  }

  function onCaptureDrop(event) {
    var target = event.target;
    if (!target) return;

    var wrapper =
      target.closest &&
      target.closest('.key_option_wrapper[data-option-type="uploadfile"], .key_options_form');
    if (!wrapper) return;

    var files = event.dataTransfer && event.dataTransfer.files;
    if (!files || !files.length) return;

    for (var i = 0; i < files.length; i++) {
      if (fileExceedsLimit(files[i])) {
        rejectOversizedUpload(wrapper.querySelector('input[type="file"]') || target, event);
        return;
      }
    }
  }

  function onSubmit(event) {
    var form = event.target;
    if (!form || !form.querySelectorAll) return;

    var inputs = form.querySelectorAll(
      '.key_options_form input[type="file"], .key_option_wrapper[data-option-type="uploadfile"] input[type="file"], input[id^="file_uf_"]'
    );

    for (var i = 0; i < inputs.length; i++) {
      if (inputHasOversizedFile(inputs[i])) {
        rejectOversizedUpload(inputs[i], event);
        return;
      }
    }
  }

  document.addEventListener('change', onCaptureChange, true);
  document.addEventListener('drop', onCaptureDrop, true);
  document.addEventListener('submit', onSubmit, true);
})();
